module.exports = __webpack_public_path__ + "img/2-5.87d2f30c.svg";